<ng-container *ngIf="sidebarVisible$ | async as visible">
  <p-sidebar
    [visible]="visible"
    [showCloseIcon]="true"
    (visibleChange)="changeNotificationSidebarVisible($event)"
    [transitionOptions]="'250ms cubic-bezier(0, 0, 0.2, 1)'"
    [closeOnEscape]="true"
    position="right"
  >
    <div class="mb-3 pl-3 d-flex align-items-center">
      <h3>Notifications</h3>
      <ng-container
        *ngIf="newNotificationCount$ | async as newNotificationCount"
      >
        <p-badge
          [value]="newNotificationCount"
          class="ml-3"
          size="large"
        ></p-badge>
      </ng-container>
    </div>

    <p-tabView (onChange)="onTabChange($event)">
      <p-tabPanel header="All">
        <ng-container *ngIf="activeTab$.value === 0">
          <ng-container *ngTemplateOutlet="test"></ng-container>
        </ng-container>
      </p-tabPanel>
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span>Critical</span>
          <ng-container
            *ngIf="
              (notificationCountByType$ | async)
                .criticalInfoUpdated as newNotificationCount
            "
          >
            <p-badge [value]="newNotificationCount" class="ml-2"></p-badge>
          </ng-container>
        </ng-template>
        <ng-container *ngIf="activeTab$.value === 1">
          <ng-container *ngTemplateOutlet="test"></ng-container>
        </ng-container>
      </p-tabPanel>
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span>Invitations</span>
          <ng-container
            *ngIf="newInvitationsCount$ | async as newInvitationsCount"
          >
            <p-badge [value]="newInvitationsCount" class="ml-2"></p-badge>
          </ng-container>
        </ng-template>
        <ng-container *ngIf="activeTab$.value === 2">
          <ng-container *ngTemplateOutlet="invations"></ng-container>
        </ng-container>
      </p-tabPanel>
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span>General</span>
          <ng-container
            *ngIf="
              (notificationCountByType$ | async)
                .generalInfoUpdated as newNotificationCount
            "
          >
            <p-badge [value]="newNotificationCount" class="ml-2"></p-badge>
          </ng-container>
        </ng-template>
        <ng-container *ngTemplateOutlet="test"></ng-container>
      </p-tabPanel>
    </p-tabView>

    <ng-template #noNotification>
      <div class="notification__empty">
        <div class="image-wrapper mb-4">
          <img src="assets/icon/chat.svg" />
        </div>
        <h4>There is nothing yet</h4>
        <p class="text--sm mt-2">There will be notifications</p>
      </div>
    </ng-template>

    <ng-template #test>
      <app-progress-spinner
        position="absolute"
        [hidden]="!loading"
      ></app-progress-spinner>
      <div
        class="container scroll-container pr-0"
        *ngIf="(allNotifications$ | async)?.length; else noNotification"
        infiniteScroll
        [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="50"
        [scrollWindow]="false"
        (scrolled)="onScroll()"
      >
        <div class="row">
          <div class="col-12">
            <ng-container *ngIf="newNotifications$ | async as newNotifications">
              <ng-container *ngIf="newNotifications.length">
                <div
                  class="d-flex align-items-center justify-content-between pb-3"
                >
                  <ng-container
                    *ngIf="
                      newNotificationCount$ | async as newNotificationCount
                    "
                  >
                    <p>{{ newNotificationCount }} NEW UPDATES</p>
                  </ng-container>
                  <p
                    class="cursor-pointer text--sm"
                    (click)="markAsDone(newNotifications)"
                  >
                    Mark as done
                  </p>
                </div>
                <div class="notification">
                  <app-notification-item
                    *ngFor="let item of newNotifications"
                    class="notification__item"
                    [item]="item"
                    [userRole]="userRole$ | async"
                  ></app-notification-item>
                </div>
                <hr />
                <br />
              </ng-container>
            </ng-container>
            <ng-container
              *ngIf="viewedNotifications$ | async as viewedNotifications"
            >
              <ng-container *ngIf="viewedNotifications.length">
                <p>Viewed</p>
                <div class="notification">
                  <ng-container
                    *ngFor="let item of viewedNotifications; let i = index"
                  >
                    <app-notification-item
                      class="notification__item"
                      [item]="item"
                      [userRole]="userRole$ | async"
                    ></app-notification-item>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #invations>
      <app-progress-spinner
        position="absolute"
        [hidden]="!loading"
      ></app-progress-spinner>
      <div
        class="container scroll-container pr-0"
        *ngIf="(newInvitatios$ | async)?.length; else noNotification"
        infiniteScroll
        [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="50"
        [scrollWindow]="false"
        (scrolled)="onScroll()"
      >
        <div class="row">
          <div class="col-12">
            <ng-container *ngIf="newInvitatios$ | async as newInvitatios">
              <ng-container *ngIf="newInvitatios.length">
                <div
                  class="d-flex align-items-center justify-content-between pb-3"
                >
                  <p>{{ newInvitatios.length }} NEW UPDATES</p>
                </div>

                <div class="notification">
                  <app-invitations-part [invitations]="allInvitatios$ | async">
                  </app-invitations-part>
                </div>
                <br />
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-template>
  </p-sidebar>
</ng-container>
